<div [@visibilityChanged]="hasNotification" class="rs-top-notification" aria-label="notification" aria-describedby="rsNotificationMessage"
    aria-live="assertive" role="alert">
    <div class="rs-top-notification-container alert" [ngClass]="{'alert-danger': isError, 'alert-info': isInfo, 'alert-warning': isWarning}">
        <span id="rsNotificationMessage">{{ notificationMessage }}</span>
    </div>
</div>